import React from 'react';
import { withRouter } from 'react-router-dom';
import { LOGIN } from '../../constants/menu_items';
import { Grid, Row, Col } from 'react-flexbox-grid';
import MainMenu from '../../containers/MainMenu';
import './styles.css';

//Images
import phone_reservando from '../../images/header/phone_reservando.png';
import playstore from '../../images/header/google_play.png';
import appstore from '../../images/header/app_store.png';
import booking from '../../images/presentation/booking.png';
import order from '../../images/presentation/order.png';
import review from '../../images/presentation/review.png';
import sale from '../../images/presentation/sale.png';
import cuadricula from '../../images/presentation/cuadricula.jpeg';
import reservando_white from '../../images/footer/logo_reservando_word_white.png';
import playstoreColor from '../../images/footer/playstore_color.svg';
import appstoreColor from '../../images/footer/appstore_color.svg';
import facebook from '../../images/image_facebook.png';
import instagram from '../../images/image_instagram.png';

const goToLogin = (props) => {
    props.history.push(`/${LOGIN}`)
}

const HomeReservando = ({ props }) => {
    return (
        <Grid className="homeReservandoCont">
            <MainMenu onLoginClick={() => goToLogin(props)} />
            <div className="imageHeaderCont">
                <h2 className="titleHeader">Ver donde salir a comer, promociones, características y reservar tu mesa en pocos segundos en los mejores restaurantes de todo el país, es más fácil.</h2>
                <div className="store">
                    <a className="imagePlaystore" href="https://play.google.com/store/apps/details?id=com.reservando.android" target="_blank" rel="noopener noreferrer"><img src={playstore} alt="imagePlaystore"/></a>
                    <a className="imageAppstore" href="https://apps.apple.com/us/app/reservando/id1454333767?l=es&ls=1" target="_blank" rel="noopener noreferrer"><img src={appstore} alt="imageAppstore"/></a>
                </div>
                <img className="imageRight" src={phone_reservando} alt="imageRight"/>
            </div>
            <Row className="presentationCont" center="xs">
                <Col xs={12} md={6} lg={3}>
                    <div className="cardCont">
                        <h3 className="titleCard">Tu mejor elección</h3>
                        <img className="iconTitleCard" src={order} alt="icon"/>
                        <hr className="separatorTitleCard"/>
                        <h4 className="textCard">Elegí entre los restaurantes que más te gustan.</h4>
                    </div>
                </Col>
                <Col xs={12} md={6} lg={3}>
                    <div className="cardCont">
                        <h3 className="titleCard">Opiniones y comentarios</h3>
                        <img className="iconTitleCard" src={review} alt="icon"/>
                        <hr className="separatorTitleCard"/>
                        <h4 className="textCard">Comentá, puntuá y ayudate con las opiniones de la comunidad.</h4>
                    </div>
                </Col>
                <Col xs={12} md={6} lg={3}>
                    <div className="cardCont">
                        <h3 className="titleCard">Los mejores beneficios</h3>
                        <img className="iconTitleCard" src={sale} alt="icon"/>
                        <hr className="separatorTitleCard"/>
                        <h4 className="textCard">Descuentos y promociones sólo para vos.</h4>
                    </div>
                </Col>
                <Col xs={12} md={6} lg={3}>
                    <div className="cardCont">
                        <h3 className="titleCard">Reservá</h3>
                        <img className="iconTitleCard" src={booking} alt="icon"/>
                        <hr className="separatorTitleCard"/>
                        <h4 className="textCard">Sin preocupaciones, gratis y en el acto.</h4>
                    </div>
                </Col>
                <Col xs={12}>
                    <img className="imageCuadricula" src={cuadricula} alt="imageCuadricula"/>
                </Col>
            </Row>
            <Row className="footer">
                <Col xs={12} className="footerTitle">
                    <img className="logoFooterTitle" src={reservando_white} alt="reservando"></img>
                </Col>
                <Col xs={12} className="footerMiddle">
                    <Row center="xs">
                        <Col xs={12} md={12} lg={4} className="footerMiddleCol">
                            <h3>Descargá nuestra app:</h3>
                            <div className="storeFooter">
                                <a className="imagePlaystore" href="https://play.google.com/store/apps/details?id=com.reservando.android" target="_blank" rel="noopener noreferrer"><img src={playstoreColor} alt="imagePlaystore"/></a>
                                <a className="imageAppstore" href="https://apps.apple.com/us/app/reservando/id1454333767?l=es&ls=1" target="_blank" rel="noopener noreferrer"><img src={appstoreColor} alt="imageAppstore"/></a>
                            </div>
                        </Col>
                        <Col xs={12} md={12} lg={4} className="footerMiddleCol">
                            <div className="contentFooter">
                                <a href="http://reservando.com.ar/faqs/" target="_blank" rel="noopener noreferrer"><h3>¿Querés saber más?</h3></a>
                                <a href="http://reservando.com.ar/terminosdeusoyprivacidad/" target="_blank" rel="noopener noreferrer"><h3>Términos y condiciones</h3></a>
                            </div>
                        </Col>
                        <Col xs={12} md={12} lg={4} className="footerMiddleCol">
                            <h3>Más sobre nosotros:</h3>
                            <div className="mediaFooter">
                                <a className="imageFacebook" href="https://www.facebook.com/reservandoarg/" target="_blank" rel="noopener noreferrer"><img src={facebook} alt="imageFacebook"/></a>
                                <a className="imageInstagram" href="https://instagram.com/reservandoarg?igshid=iq8lodigh7pq" target="_blank" rel="noopener noreferrer"><img src={instagram} alt="imageInstagram"/></a>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} className="footerBottom">
                    <h4 className="copyrightText">Copyright ©2019 Reservando</h4>
                </Col>
            </Row>
        </Grid>
    );
};

HomeReservando.propTypes = {
    
};

export default withRouter(HomeReservando);